import ChangeMethodCore from 'components/RwdBasket/Carts/CartLayout/SkuItem/ChangeMethod/ChangeMethodCore/ChangeMethodCore';
import { withChangeMethodCoreProps } from 'viewModel/changeMethodCore/withChangeMethodCoreProps';

export default withChangeMethodCoreProps(ChangeMethodCore);
